export default __webpack_public_path__ + "static/1-2a4046a762dcd1d093269bcb70b346ff.jpg";